export function markAgGridDatePickerPopup(instance) {
  instance.calendarContainer?.classList.add("ag-custom-component-popup")
}
